var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.selectMode ? _c('v-select', {
    ref: "field",
    attrs: {
      "id": _vm.inputId,
      "items": _vm.items,
      "item-text": _vm.itemText,
      "item-value": _vm.selectedKey,
      "label": _vm.labelText,
      "value": _vm.value,
      "loading": _vm.isLoading,
      "clearable": _vm.clearable,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "placeholder": _vm.placeholder,
      "menu-props": _vm.mergedMenuProps,
      "return-object": false,
      "dense": _vm.dense,
      "flat": _vm.flat,
      "background-color": _vm.backgroundColor,
      "hide-details": _vm.hideDetails,
      "outlined": _vm.outlined,
      "error-messages": _vm.errorMessages,
      "prepend-inner-icon": _vm.icon ? _vm.iconName(_vm.icon) : null
    },
    on: {
      "input": _vm.onSelectInput,
      "click:clear": _vm.clearSelection,
      "update:menu": _vm.onMenuChange,
      "click": _vm.onActivate,
      "focus": _vm.onActivate
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function fn() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$translate("no_results")))])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "append-item",
      fn: function fn() {
        return [_vm.hasMore && !_vm.isLoading ? _c('v-list-item', {
          on: {
            "click": _vm.loadMore
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', [_c('b', [_vm._v(_vm._s(_vm.$translate("load_more")))])])], 1)], 1) : _vm._e(), _vm.isLoading ? _c('v-progress-linear', {
          attrs: {
            "indeterminate": ""
          }
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "selection",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._t("selection", function () {
          return [_vm._v(" " + _vm._s(_vm.itemText(item)) + " ")];
        }, {
          "item": item
        })];
      }
    }, {
      key: "item",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._t("item", function () {
          return [_c('v-list-item-title', [_vm._v(_vm._s(_vm.itemText(item)))])];
        }, {
          "item": item
        })];
      }
    }], null, true)
  }) : _c('v-autocomplete', {
    ref: "field",
    attrs: {
      "id": _vm.inputId,
      "items": _vm.items,
      "item-text": _vm.itemText,
      "item-value": _vm.selectedKey,
      "label": _vm.labelText,
      "search-input": _vm.localSearch,
      "value": _vm.value,
      "loading": _vm.isLoading,
      "clearable": _vm.clearable,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "placeholder": _vm.placeholder,
      "menu-props": _vm.mergedMenuProps,
      "return-object": false,
      "no-filter": true,
      "dense": _vm.dense,
      "flat": _vm.flat,
      "background-color": _vm.backgroundColor,
      "hide-details": _vm.hideDetails,
      "outlined": _vm.outlined,
      "error-messages": _vm.errorMessages,
      "prepend-inner-icon": _vm.icon ? _vm.iconName(_vm.icon) : null
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.localSearch = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.localSearch = $event;
      },
      "change": _vm.onChange,
      "click:clear": _vm.clearSelection,
      "update:menu": _vm.onMenuChange,
      "click": _vm.onActivate
    },
    nativeOn: {
      "keyup": function keyup($event) {
        return _vm.debouncedEmit(_vm.localSearch);
      }
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function fn() {
        return [_c('v-list-item', [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$translate("no_results")))])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "append-item",
      fn: function fn() {
        return [_vm.hasMore && !_vm.isLoading ? _c('v-list-item', {
          on: {
            "click": _vm.loadMore
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', [_c('b', [_vm._v(_vm._s(_vm.$translate("load_more")))])])], 1)], 1) : _vm._e(), _vm.isLoading ? _c('v-progress-linear', {
          attrs: {
            "indeterminate": ""
          }
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "item",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._t("item", function () {
          return [_c('v-list-item-title', [_vm._v(_vm._s(_vm.itemText(item)))])];
        }, {
          "item": item
        })];
      }
    }], null, true)
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }